const strengthsJSON = {
  section: 'SAW',
  topic: 'Strengths and Challenges',
  checked: 'true',
  // access: "private",
  color: 'secondary',
  description: '(optional)',
  body: [
    {
      id: 'SAW.1',
      shortname: 'saw1',
      mandatory: 'true',
      name: 'In my opinion I have the following personal strengths and positive personality characteristics:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW1',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'SAW.2',
      shortname: 'saw2',
      mandatory: 'true',
      name: 'In my opinion I have the following personal challenges and negative personality characteristics:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW2',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    // {
    //   id: "SAW.3",
    //   access: "private",
    //   shortname: "saw3",
    //   mandatory: "true",
    //   name:
    //     "In this evaluator’s opinion this patient has the following personal strengths and positive personality characteristics:",
    //   prevalue: "",
    //   value: "",
    //   disabled: "false",
    //   type: "text",
    //   act: "SAW3",
    //   depending: "",
    //   exception: "",
    //   extend: "",
    //   link: "",
    // },
    {
      id: 'SAW.3',
      shortname: 'saw3-vir',
      name: "In this evaluator's opinion this patient has the following personal strengths and positive characteristics. Document individual's strengths, preferences, extracurricular, community and social activities, extended family; activities that the individual engages in or are meaningful to the individual.",
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'subtopic',
      act: 'SAW3-VIR',
      depending: '',
      exception: '',
    },
    {
      id: 'SAW.3',
      shortname: 'saw3-left',
      name: '',
      prevalue: '',
      disabled: 'false',
      value: [],
      type: 'checkbox',
      radio_options: [
        'Capable of Independence',
        'Insightful',
        'Reliable',
        'Responsible',
        'Physical Health',
        'Integrated Moral Values',
        'Motivated',
        'Confident',
        'Positive Support Network',
        'Communication',
        'Organization',
      ],
      act: 'SAW3-LEFT',
      depending: '',
      exception: '',
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-LEFT',
      subtopic_name: '',
    },
    {
      id: 'SAW.3',
      shortname: 'saw3-right',
      name: '',
      prevalue: '',
      disabled: 'false',
      value: [],
      type: 'checkbox',
      radio_options: [
        'Supportive Family',
        'Accepts Guidance/Feedback',
        'Reasonable Judgement',
        'Varied Interest',
        'Clear Thinking',
        'Good Personal Care Habits',
        'Expressive/Articulate',
        'Sociable',
        'Critical Thinking',
        'Other',
      ],
      act: 'SAW3-RIGHT',
      depending: '',
      exception: '',
      link: 'SAW3-RIGHT-OTHER',
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-RIGHT',
      subtopic_name: '',
    },
    {
      id: 'SAW.3',
      extend: 'true',
      shortname: 'saw3-right-other',
      name: '',
      prevalue: 'Please, explain:',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'SAW3-RIGHT-OTHER',
      depending: 'SAW3-RIGHT',
      exception: 'Other',
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-RIGHT',
      subtopic_name: '',
    },
    {
      id: 'SAW.4',
      access: 'private',
      shortname: 'saw4',
      mandatory: 'true',
      name: 'In this evaluator’s opinion this patient has the following personal challenges and negative personality characteristics:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW4',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
  ],
};

export default strengthsJSON;
